<template>
      <div>
        <b-icon v-if="data.state == false" icon="x-octagon" variant="danger" animation="throb" font-scale="8" />
        <hr>
        <h3 class="mb-0">  {{$t('general.sure')}} </h3>
        <p v-if="data.state == false"> {{data.ticket.title}} başlıklı desteği kapatmak istiyor musunuz?</p>
   </div>
</template>

<script>
    export default {
        name: "SetState",
        props: {
            data: Object,
            save: Boolean,
            saveState: Function,
            modalEvent: Function,
            modalName: String
        },
         watch: {
            save: async function(data){
                if(data){
                    await this.$store.dispatch('closeTicket', this.data.ticket.id)
                    if (this.$store.getters.getTicketStatus == 'Success') {
                        await this.$store.dispatch('fetchTickets')
                        this.saveState(false)
                        this.modalEvent(false)
                        return
                    }
                }
                this.saveState(false)
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/Support/Ticket/modals/SetState.vue